<script setup>
import TicketService from "@/api/services/ticket.service";
import notification from "@/utils/plugins/NotificationService";

import { ref } from "vue";


const props = defineProps({
  placeholder: {
    type: String
  },
  isPrivate: {
    type: Boolean,
    required: true
  },
  ticket: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(["refresh"]);


const formModel = ref({
  comment: null,
  ticket: props.ticket['@id'],
  // El autor lo pone el back con el usuario autenticado
  private: props.isPrivate
});

const showCommentButton = ref(false);

function submit() {
  if (!formModel.value.comment || formModel.value.comment.length < 2) {
    notification.addNotification("No puede enviar un comentario en blanco", "error", 10000);
    return;
  }
  TicketService.createComment(formModel.value).then(() => {
    formModel.value.comment = "\n";
    emit('refresh');
  });
  notification.addNotification("Comentario creado correctamente", "success", 10000);
}

function onTextChanged() {
  let temp = removeHtmlTags(formModel.value.comment);
  if (temp.length >= 2) {
    showCommentButton.value = true;
  } else {
    showCommentButton.value = false;
  }
  if (temp.length < 1) {
    formModel.value.comment = "";
  }
}

function removeHtmlTags(input) {
  return input.replace(/<[^>]*>/g, '');
}
</script>

<template>
  <div class="container m-0 p-0 mt-3 pb-5">
    <!-- <textarea
      v-model="formModel.comment"
      class="border-none"
      :placeholder="placeholder"
    /> -->
    <QuillEditor
      v-model:content="formModel.comment"
      contentType="html"
      @text-change="onTextChanged"
      theme="snow"
      class="quillNew"
    />
    <div class="mt-3">
      <button
          :disabled="!formModel.comment || !showCommentButton"
          class="btn btn_red btn-comment float-right"
          style="width: 170px;"
          @click="submit()"
      >
        <img
          width="21"
          height="25"
          class="mr-2"
          src="@/assets/icons/message-white.svg"
          alt=""
        >COMENTAR
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
 textarea {
   border-radius: 0;
   width: 100%;
   border: none!important;
   background-color: #EDF2FA;
   padding: 10px;
   font-size: 20px;
 }
 .btn-comment{
   height: 45px;
   color: #FFFFFF;
   min-width: 200px;
   font-size: 20px;
   width: 100%;
   font-weight: 500;
 }


.quillNew{
  color: red !important;
}


</style>
